// extracted by mini-css-extract-plugin
export default {"BodyScroll":"BodyScroll__BodyScroll___pXx9Q","fixed":"BodyScroll__fixed___bZmIo","active":"BodyScroll__active___W03JV","pointerEvents":"BodyScroll__pointerEvents___SZg3X"};